import Bestellung from "@/entities/common/bestellung"
import {
  AbholzeitType,
  Bezahlart,
  LieferungStatus,
} from "@/entities/common/enums"
import RemoteResult from "@/entities/common/remote_result"
import IdRequest from "@/entities/common/request/id_request"
import store from "@/store"
import Poster from "@/util/poster"
import RestPaths from "@/util/rest_paths"
import SocketMessageType from "@/util/socket_message_types"
import Formatter from "../formatter"
import BaseLogic from "../base_logic"

export default class DetailsLieferungLogic extends BaseLogic {
  navigator: Navigator = null

  init(navigator: Navigator) {
    this.navigator = navigator

    store.watch(
      (state) => state.incomingMessage,
      (newValue) => {
        if (newValue) {
          if (newValue.type == SocketMessageType.LIEFERUNG_STATUS_UPDATE) {
            var payload = JSON.parse(newValue.payload)
            if (payload.id == this.mainLogic.bestellung.id) {
              var status = payload.status
              this.mainLogic.bestellung.lieferung.lieferungStatus =
                status

              this.reloadBestellung()
            }
          }
        }
      }
    )
  }

  berechneGesamtpreis(): number {
    var artikellistepreis = Formatter.berechnePreisListe(
      this.mainLogic.bestellung.artikelliste
    )
    var lieferkosten =
      this.mainLogic.bestellung.lieferung.lieferkosten
    if (!lieferkosten) lieferkosten = 0
    return artikellistepreis + lieferkosten
  }

  berechneGesamtpreisTrinkgeld(): number {
    var gesamtpreis = this.berechneGesamtpreis()

    var trinkgeld = this.mainLogic.bestellung.trinkgeld
    if (trinkgeld != null) {
      gesamtpreis = gesamtpreis + trinkgeld
    }
    return gesamtpreis
  }

  reloadBestellung() {
    var request = new IdRequest()
    request.id = this.mainLogic.bestellung.id

    Poster.postUser<RemoteResult<Bestellung>>(
      RestPaths.bestellungKundeDetails,
      request
    ).then((response) => {
      if (response.data.success) {
      }
    })
  }

  formatiereBezahlart() {
    var bezahlart = this.mainLogic.bestellung.bezahlart
    if (bezahlart == Bezahlart.BARZAHLUNG) {
      return "Zahlung bei Lieferung"
    } else if (bezahlart == Bezahlart.PAYPAL) {
      return "Paypal"
    }
    return null
  }

  computeGewuenschteLieferzeit(): string {
    if (
      this.mainLogic.bestellung.lieferung.zeitType ==
      AbholzeitType.BALDEST
    ) {
      return "schnellst möglich"
    } else if (
      this.mainLogic.bestellung.lieferung.zeitType ==
      AbholzeitType.UHRZEIT
    ) {
      return Formatter.formatiereDatumUhrzeit(
        this.mainLogic.bestellung.lieferung.lieferzeitpunkt
      )
    }
  }

  bestimmeBild(bestellung: Bestellung) {
    if (bestellung == null) return null
    var bildId = this.filiale.bildId
    if (bildId == null) return null
    return RestPaths.urlBase + "image/image2/" + bildId
  }

  formatiereStatus() {
    if (this.mainLogic.bestellung == null) return null
    switch (this.mainLogic.bestellung.lieferung.lieferungStatus) {
      case LieferungStatus.ABGESENDET:
        return "Bestellung noch nicht angenommen"
      case LieferungStatus.ANGENOMMEN:
        return "Bestellung angenommen"
      case LieferungStatus.ABGELEHNT:
        return "Bestellung abgelehnt"
      case LieferungStatus.IN_ZUBEREITUNG:
        return "Bestellung in Zubereitung"
      case LieferungStatus.ZUBEREITET:
        return "Bestellung zubereitet"
      case LieferungStatus.IN_LIEFERUNG:
        return "Bestellung in Lieferung"
      case LieferungStatus.GELIEFERT:
        return "Bestellung ausgeliefert"
    }
  }
}
